import TextField from "@mui/material/TextField";
import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
import { SubTitle, Text } from "utils/styling/typography.styled";

export const ModalContainer = styled.div`
    background-color: ${colourScheme.primaryDark};
    border-radius: 0.5rem;
    padding: 2rem;
    gap: 1rem;
    width: 100vw;
    max-width: 100%;
    box-shadow: 0 0.625rem 1.25rem rgba(0, 0, 0, 0.5);
    color: ${colourScheme.fullWhite};
    margin: 0 auto;

    ${device.md} {
        max-width: 80vw;
        padding: 2.5rem;
    }

    ${device.lg} {
        max-width: 60vw;
        padding: 3rem;
    }

    ${device.xl} {
        max-width: 50vw;
    }

    & > * {
        margin-bottom: 1.5rem; // Adds space between elements within the modal
    }
`;

export const ModalTitle = styled(SubTitle)`
    margin-bottom: 1rem;
`;

export const ModalText = styled(Text)`
    margin-bottom: 1.5rem;
`;

export const SearchTextField = styled(TextField)`
    margin-bottom: 1.5rem; // Space below the search input

    & .MuiInputBase-root {
        background-color: ${colourScheme.primary};
        color: ${colourScheme.white};
    }

    & .MuiOutlinedInput-notchedOutline {
        border-color: ${colourScheme.primaryLight};
    }

    &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${colourScheme.secondary};
    }

    & .MuiInputLabel-root {
        color: ${colourScheme.fullWhite};
    }

    & .MuiInputLabel-shrink {
        color: ${colourScheme.secondary};
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
`;
